import React from 'react'
import { useLocation } from 'react-router-dom'

import useMediaQuery from '../../../hooks/useMediaQuery'
import { useScheduleVM } from './hooks/useScheduleVM'
import { ScheduleMobileView } from './ScheduleMobileView'
import { ScheduleDesktopView } from './ScheduleDesktopView'
import './ScheduleSh.scss'

export default function ScheduleSh(): JSX.Element {
    const { pathname } = useLocation()
    const isDesktop = useMediaQuery('(min-width: 992px)')
    const isWithSidebar = isDesktop && pathname.startsWith('/landlord')
    const vm = useScheduleVM({ isWithSidebar })

    return isWithSidebar
        ? <ScheduleDesktopView vm={vm} />
        : <ScheduleMobileView vm={vm} />
}
